var _path, _rect, _path2, _circle, _circle2, _rect2, _path3, _rect3, _circle3, _circle4, _circle5, _rect4, _rect5, _rect6, _rect7, _circle6, _path4, _path5, _rect8, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 190,
    viewBox: "0 0 268 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 181.183H261.5C239 78.183 187.5 153.683 187.5 153.683C184.5 167.183 159.5 145.183 159.5 145.183C111.5 93.183 123.5 182.683 95.5 166.183C55 124.183 52.5 184.183 30.5 178.183C30.5 178.183 9 166.183 5 181.183Z",
    fill: "#3681D3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 177.5,
    y: 143.5,
    width: 41,
    height: 38,
    rx: 1.5,
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 99.4999C17.3728 93.7742 22.6843 96.2444 25.0682 98.1116C26.0902 98.9121 26.5 100.202 26.5 101.5V168C26.5 171.314 29.1863 174 32.5 174H75.5",
    stroke: "#212429"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    transform: "matrix(1 0 0 -1 23 183)",
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    transform: "matrix(1 0 0 -1 62 183)",
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 220.5,
    y: 152.5,
    width: 30,
    height: 29,
    rx: 1.5,
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6229 148.374L30.7822 135.269C29.3083 134.385 29.5628 132.176 31.1992 131.65L64.5559 120.928C66.2301 120.39 67.7339 122.12 66.9686 123.703L55.4526 147.529C54.941 148.588 53.6311 148.979 52.6229 148.374Z",
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 150.5,
    width: 38,
    height: 21,
    rx: 1.5,
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 25 181)",
    fill: "#212429"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 64 181)",
    fill: "#212429"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 166,
    r: 16.5,
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 144,
    width: 5,
    height: 37,
    fill: "#3681D3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 169,
    width: 4,
    height: 29,
    transform: "rotate(-90 221 169)",
    fill: "#3681D3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 116.5,
    width: 25,
    height: 25,
    rx: 1.5,
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 183.719,
    y: 127.658,
    width: 4,
    height: 15.2365,
    rx: 1.5,
    transform: "rotate(23.4423 183.719 127.658)",
    fill: "#F8F9FB",
    stroke: "#212429"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 138,
    r: 4,
    fill: "#03366D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 148.5V141.328C220.5 139.547 222.654 138.654 223.914 139.914L231.086 147.086C232.346 148.346 231.453 150.5 229.672 150.5H222.5C221.395 150.5 220.5 149.605 220.5 148.5Z",
    fill: "#03366D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 184H268",
    stroke: "#212429"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 151,
    width: 5,
    height: 20,
    fill: "#3681D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.943 58.0574L158.743 61.2572C158.597 61.4035 158.555 61.6247 158.639 61.8138L160.182 65.2848C160.33 65.6186 160.775 65.6859 161.015 65.411L163.425 62.6568C163.68 62.366 164.176 62.4596 164.416 62.7629C166.181 65 171.78 65 174.5 65C175.946 65 176.462 63.6069 175.603 63.0583C175.538 63.0165 175.459 63.0003 175.381 62.999C170.647 62.9165 167.286 57.9357 167.017 57.5267C167.004 57.5069 166.994 57.4932 166.978 57.4756C166.707 57.1736 163.938 54.2376 162.038 57.9251C162.013 57.9729 161.981 58.0194 161.943 58.0574Z",
    fill: "#03366D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.073 50.4041C128.593 49.871 115.687 47.3998 101.895 50.4121C101.665 50.4623 101.502 50.668 101.504 50.9035L101.997 102.684C101.999 102.877 102.115 103.054 102.29 103.135C117.162 110.018 124.625 111.726 135.732 111.05C136.093 111.028 136.316 110.648 136.156 110.325C127.195 92.2053 130.961 55.3378 131.45 50.9333C131.478 50.6812 131.321 50.4574 131.073 50.4041Z",
    fill: "#3681D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141 79.5L130.5 67V49C130.5 49 134 49 137 53.5L149 69L159 58.5L164.5 70.5L154.5 79.5C154.5 79.5 146 87.5 141 79.5Z",
    fill: "#F8F9FB",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.7 190H110.881C110.308 190 109.978 189.348 110.317 188.886L114.79 182.786C114.922 182.606 115.132 182.5 115.355 182.5H118.887C119.238 182.5 119.535 182.76 119.581 183.107L120.394 189.207C120.45 189.627 120.124 190 119.7 190Z",
    fill: "#03366D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.324 182.5H130.652C130.285 182.5 129.98 182.784 129.954 183.15L129.554 188.75C129.525 189.155 129.846 189.5 130.252 189.5H145.724C146.451 189.5 146.696 188.528 146.055 188.184L135.655 182.584C135.553 182.529 135.439 182.5 135.324 182.5Z",
    fill: "#03366D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.528 101.75C104.58 103.158 109.728 106.29 118.177 108.901C118.37 108.961 118.51 109.102 118.528 109.304C119.476 120.04 120.848 174.851 120.988 180.525C120.995 180.806 120.769 181 120.488 181H112.936C112.686 181 112.475 180.816 112.441 180.568L101.673 102.261C101.612 101.811 102.153 101.493 102.528 101.75Z",
    fill: "#F8F9FB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.994 133.964C126.87 133.272 124.922 122.623 119.887 110.426C119.73 110.045 120.069 109.649 120.467 109.754C122.792 110.364 127.177 111.403 135.164 111.017C135.365 111.007 135.554 111.113 135.641 111.295C136.592 113.298 142.065 124.938 143 129.5C144.016 134.462 143.015 142.872 143 142.999L142.999 143.006L137.562 180.572C137.526 180.818 137.316 181 137.067 181H128C127.724 181 127.5 180.79 127.5 180.514V141.5C127.5 138.777 127.996 137.014 127.012 134.036C127.004 134.012 126.998 133.989 126.994 133.964Z",
    fill: "#F8F9FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.528 101.75C104.58 103.158 109.728 106.29 118.177 108.901C118.37 108.961 118.51 109.102 118.528 109.304C119.476 120.04 120.848 174.851 120.988 180.525C120.995 180.806 120.769 181 120.488 181H112.936C112.686 181 112.475 180.816 112.441 180.568L101.673 102.261C101.612 101.811 102.153 101.493 102.528 101.75Z",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.994 133.964C126.87 133.272 124.922 122.623 119.887 110.426C119.73 110.045 120.069 109.649 120.467 109.754C122.792 110.364 127.177 111.403 135.164 111.017C135.365 111.007 135.554 111.113 135.641 111.295C136.592 113.298 142.065 124.938 143 129.5C144.016 134.462 143.015 142.872 143 142.999L142.999 143.006L137.562 180.572C137.526 180.818 137.316 181 137.067 181H128C127.724 181 127.5 180.79 127.5 180.514V141.5C127.5 138.777 127.996 137.014 127.012 134.036C127.004 134.012 126.998 133.989 126.994 133.964Z",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.375 57.8333L70.7473 72.8406C70.6264 73.163 70.2235 73.2696 69.959 73.0492L49.7839 56.2366C49.6152 56.096 49.558 55.8617 49.6429 55.6591L55.7391 41.1222C55.8689 40.8126 56.2609 40.7164 56.5193 40.9307L76.226 57.2728C76.39 57.4088 76.4498 57.6338 76.375 57.8333Z",
    fill: "#F8F9FB",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39L77 56",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9995 61.5C53.9995 69.5 63.4995 66.5 63.4995 66.5L61.4995 65C66 57.5 59.5 58 58.9995 59C60 56.5 58.5 56.5 57.9995 57.5L54.9995 61.5Z",
    fill: "#03366D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92 78.9999L102.886 66.6295C102.96 66.5455 103.003 66.4393 103.01 66.3277L103.984 49.2857C103.994 49.1087 103.91 48.9407 103.745 48.8756C102.922 48.5511 100.15 48.02 96 52.9999C91.6625 58.2049 85.82 66.42 84.3478 68.5058C84.1659 68.7634 83.7967 68.7874 83.5786 68.5594L73.4529 57.9735C73.2249 57.7351 72.8326 57.7789 72.6629 58.0618L67.2009 67.1652C67.0828 67.3619 67.1138 67.6137 67.276 67.776L71 71.4999L79.5 79.9999C79.5 79.9999 86.5 86.9999 92 78.9999Z",
    fill: "#F8F9FB",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.375 133.05C100.539 137.022 105.525 139.499 107.356 140.254C107.671 140.384 108 140.148 108 139.806V86C108 85.9999 108 53.8545 108 49.0727C108 48.7636 107.723 48.4564 107.417 48.4184C105.918 48.233 101.955 47.9021 100.614 49.3627C100.536 49.4479 100.502 49.5474 100.507 49.6629C100.594 51.7522 101.451 73.5783 100.5 94.5C99.5108 116.269 97.5423 130.205 97.501 130.495C97.4997 130.505 97.4992 130.505 97.4975 130.514C97.1613 132.274 100.068 132.285 101.788 132.143C102.234 132.106 102.562 132.644 102.375 133.05Z",
    fill: "#F8F9FB",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129 101.5C129 101.5 136.5 110 140.5 122L132.5 95V49.5C132 49 126.5 48 124 49.5C125.5 59 124 84 124 84C122 96.5 126.5 97 129 101.5Z",
    fill: "#F8F9FB",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108 57.0001V89.5001L103.5 54.0001C110 40.0001 130.5 48.0001 129.5 55.5001L123.5 89.5001L125 57.0001C122 42.5001 106.5 49.7603 108 57.0001Z",
    fill: "#F8F9FB",
    stroke: "#212429",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.111 50.2414L113.854 43.8425C113.941 43.6393 113.874 43.3949 113.706 43.2509C99.5128 31.0605 118.383 19.9596 126.107 29.9582C126.31 30.2208 126.187 30.6043 125.873 30.7093L125.536 30.8216C125.251 30.9164 125.114 31.2388 125.242 31.51L129.479 40.4553C129.493 40.485 129.505 40.5175 129.513 40.5495C130.433 44.3315 127.753 44.9501 127.517 44.9969C127.505 44.9994 127.494 45.0006 127.481 45.0018C122.074 45.4979 122 47.4512 121.52 51.3402C121.508 51.4432 121.466 51.5379 121.392 51.611C120.61 52.3886 115.712 56.8138 111.17 50.7327C111.066 50.5927 111.042 50.402 111.111 50.2414Z",
    fill: "#03366D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119 31C121.5 33 124 30.0001 126 30.5001C117 20.0001 101 33 113.999 43C112.5 40.0001 115.5 38.5 115.5 38.5C116.5 38 117.5 38 116.5 34C115 30 118.5 30 119 31Z",
    fill: "#F8F9FB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M112.778 8.34653C112.569 7.98453 112.448 7.63706 112.417 7.30412C112.39 6.95388 112.404 6.66081 112.458 6.4249C112.523 6.18266 112.632 5.8271 112.786 5.35822C112.804 5.28901 112.874 5.08052 112.995 4.73276C113.12 4.36771 113.173 4.01554 113.153 3.67627C113.126 3.32603 113.021 2.99185 112.837 2.67373C112.533 2.14718 112.104 1.80973 111.551 1.66137C110.997 1.513 110.457 1.59082 109.93 1.89482C109.404 2.19882 109.067 2.64181 108.92 3.22378C108.778 3.78844 108.859 4.33405 109.163 4.86059L109.477 5.40359L108.33 6.00022L108.045 5.50659C107.728 4.95811 107.574 4.38847 107.584 3.79769C107.588 3.19593 107.747 2.6359 108.062 2.1176C108.377 1.5993 108.815 1.17864 109.374 0.855645C109.934 0.532645 110.506 0.370629 111.09 0.369598C111.679 0.351264 112.223 0.483172 112.723 0.765322C113.222 1.04747 113.624 1.45182 113.928 1.97836C114.175 2.40618 114.321 2.81166 114.367 3.19481C114.423 3.57163 114.418 3.90395 114.35 4.19176C114.287 4.46228 114.183 4.81467 114.039 5.24894C114.009 5.32449 113.937 5.54162 113.823 5.90035C113.702 6.24811 113.65 6.57749 113.669 6.88848C113.681 7.18851 113.77 7.48113 113.935 7.76635L114.353 8.49034L113.234 9.13634L112.778 8.34653ZM113.981 11.3813C113.823 11.107 113.783 10.8229 113.862 10.5287C113.952 10.2282 114.139 9.99564 114.424 9.83098C114.699 9.67264 114.983 9.63288 115.277 9.7117C115.582 9.78419 115.814 9.95755 115.972 10.2318C116.137 10.517 116.178 10.8153 116.094 11.1268C116.022 11.4319 115.848 11.6636 115.574 11.822C115.289 11.9866 114.99 12.0272 114.679 11.9438C114.378 11.854 114.146 11.6665 113.981 11.3813Z",
    fill: "#212429"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProducts);
export default __webpack_public_path__ + "static/media/empty-products.39e9b9cdc6d4fd55891c7fb4500eb3e0.svg";
export { ForwardRef as ReactComponent };